import { apiConfig } from "./apiConfig";

export const firmwareApi = apiConfig.injectEndpoints({
  endpoints: (builder) => ({
    getFirmwareList: builder.query<
      any,
      {
        startKey: string;
        page_size?: number | string;
        brand_id: string | null;
        family_id: string | null;
      }
    >({
      query: ({ startKey, page_size, brand_id, family_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/firmware`,
        params: {
          start_key: startKey,
          page_size: Number(page_size),
        },
      }),
      providesTags: ["Firmware"],
    }),

    createFirmware: builder.mutation<
      any,
      { brand_id: string | null; family_id: string | null; body: any }
    >({
      query: ({ body, brand_id, family_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/firmware`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Firmware"],
    }),

    getSingleFirmwareDetails: builder.query<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        firmware_id: string | null;
      }
    >({
      query: ({ brand_id, family_id, firmware_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/firmware/${firmware_id}`,
      }),
    }),

    editFirmware: builder.mutation<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        firmware_id: string | null;
        body: any;
      }
    >({
      query: ({ brand_id, body, family_id, firmware_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/firmware/${firmware_id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["Firmware"],
    }),
  }),
});

export const {
  useLazyGetFirmwareListQuery,
  useCreateFirmwareMutation,
  useLazyGetSingleFirmwareDetailsQuery,
  useEditFirmwareMutation,
} = firmwareApi;
